module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-upload"
  }, [_c('div', {
    staticClass: "right-wrapper"
  }, [_c('div', {
    staticClass: "right-box",
    attrs: {
      "id": "right"
    }
  }, [_c('form', {
    staticClass: "bk-form"
  }, [_c('div', {
    staticClass: "upload-panel",
    attrs: {
      "id": "anchor-1"
    }
  }, [_c('h4', [_vm._v("基础资料")]), _vm._v(" "), _c('div', {
    staticClass: "upload-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('single-selector', {
    staticStyle: {
      "width": "168px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.sysTypeList,
      "setting-key": 'id',
      "selected": _vm.baseInfo.sys_type_id,
      "disabled": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "sys_type_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.baseInfo.sys_type_id == 1) ? _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInfo.app_code),
      expression: "baseInfo.app_code"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "536px"
    },
    attrs: {
      "type": "text",
      "disabled": "",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.baseInfo.app_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInfo, "app_code", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('single-selector', {
    staticStyle: {
      "width": "168px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.funcTypeList,
      "setting-key": 'id',
      "selected": _vm.baseInfo.func_type_id,
      "disabled": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "func_type_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.isFieldWarning('name')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInfo.name),
      expression: "baseInfo.name"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "此处输入你上传的作品名称，建议30个字符以内"
    },
    domProps: {
      "value": (_vm.baseInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInfo, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.check.name.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.isFieldWarning('desc')
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInfo.desc),
      expression: "baseInfo.desc"
    }],
    staticClass: "bk-form-textarea",
    staticStyle: {
      "width": "614px",
      "min-height": "70px"
    },
    attrs: {
      "maxlength": "50",
      "name": "validation_name",
      "placeholder": "请输入产品的详细介绍"
    },
    domProps: {
      "value": (_vm.baseInfo.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInfo, "desc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bk-form-number"
  }, [_vm._v(_vm._s(_vm.baseInfo.desc.length))]), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.check.desc.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.isFieldWarning('feature')
  }, [_c('div', {
    staticStyle: {
      "width": "614px"
    }
  }, [_c('script', {
    staticStyle: {
      "width": "614px",
      "min-height": "200px"
    },
    attrs: {
      "type": "text/plain",
      "id": "myEditor"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.check.feature.tips))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("\n                  体验地址：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.isFieldWarning('test_url')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInfo.test_url),
      expression: "baseInfo.test_url"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "请在此处输入作品的线上体验地址，有助于用户直观的了解你的作品。"
    },
    domProps: {
      "value": (_vm.baseInfo.test_url)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInfo, "test_url", $event.target.value)
      }, function($event) {
        return _vm.checkValidate('test_url')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "41%"
    }
  }, [_vm._v(_vm._s(_vm.check.test_url.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "language"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.langList,
      "selected": _vm.baseInfo.language_id,
      "multi-select": true,
      "searchable": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "language_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "browser"
    }
  }, [_c('selector', {
    ref: "browser",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.browserList,
      "selected": _vm.baseInfo.browser_id,
      "multi-select": true,
      "searchable": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "browser_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "surroundings"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.envList,
      "selected": _vm.baseInfo.deploy_id,
      "multi-select": true,
      "searchable": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "deploy_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "interface"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.i18nList,
      "selected": _vm.baseInfo.i18n_id,
      "multi-select": true,
      "searchable": true
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInfo, "i18n_id", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('tag', {
    attrs: {
      "tags": _vm.baseInfo.labels,
      "placeholder": "请输入不超过5个关键词作为标签，明确的关键词能够帮助用户更精准快速的定位到你的作品！"
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.baseInfo, "labels", $event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "upload-action"
  }, [_c('a', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "id": "submit",
      "title": "提交"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("提交")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button bk-return",
    attrs: {
      "title": "返回"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('span', [_vm._v("返回")])])])])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 作品类型：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v("应用ID：\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 功能类型：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 作品名称：\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 简要概述：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 作品介绍：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 开发语言：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 浏览器兼容：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 部署环境：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 界面语言：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 分类标签：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bd084cb2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/basic_information.vue
// module id = ppbZ
// module chunks = 16